// src/pages/OpportunitiesPage.jsx
// C3.2.2.3 — OpportunitiesPage Lead Web ORBIS: dark grid + pipeline sin blancos
// CRM Multicampaña + Pipeline ORBIS PMO

import React, { useEffect, useMemo, useRef, useState } from "react";
import MainLayout from "../layout/MainLayout";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../config/orbisConfig";



function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table {
                border-collapse: separate;
                border-spacing: 0;
                background: #061A2F;
            }
            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
                background: #08233D !important;
            }
            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #092A49 !important;
            }
            .grid-rows-pro table tbody td {
                border-top: 1px solid #24587C;
                background: transparent !important;
            }
            .grid-rows-pro table tbody tr.grid-row-clickable { cursor: pointer; }
            .grid-rows-pro table tbody tr:hover {
                background: rgba(56, 189, 248, 0.075) !important;
                box-shadow: inset 3px 0 0 #D4AF37;
            }
            .grid-rows-pro table tbody tr:hover td {
                background: transparent !important;
            }
            .grid-rows-pro table thead th.sortable { cursor: pointer; user-select: none; }
            .grid-rows-pro table thead th.sortable:hover {
                color: #F8E5A4;
                background: rgba(212,175,55,0.08);
            }
            .grid-rows-pro .sticky-grid-head th {
                position: sticky; top: 0; z-index: 20;
                background: #061A2F !important;
                color: #94a3b8;
                box-shadow: inset 0 -1px 0 #24587C;
                border-bottom: 1px solid #24587C;
            }
            .grid-top-scroll {
                overflow-x: auto; overflow-y: hidden;
                height: 14px; border: 1px solid #24587C;
                border-radius: 999px; background: #061A2F;
            }
            .grid-top-scroll-inner { height: 1px; }
            .grid-table-scroll {
                overflow: auto;
                max-height: 68vh;
                border-radius: 16px;
                border: 1px solid #24587C;
                background: #08233D !important;
            }
            .opps-dark select option { background: #061A2F; color: white; }
            .opps-dark-scroll::-webkit-scrollbar,
            .grid-table-scroll::-webkit-scrollbar,
            .grid-top-scroll::-webkit-scrollbar { height: 10px; width: 10px; }
            .opps-dark-scroll::-webkit-scrollbar-track,
            .grid-table-scroll::-webkit-scrollbar-track,
            .grid-top-scroll::-webkit-scrollbar-track { background: #061A2F; border-radius: 999px; }
            .opps-dark-scroll::-webkit-scrollbar-thumb,
            .grid-table-scroll::-webkit-scrollbar-thumb,
            .grid-top-scroll::-webkit-scrollbar-thumb { background: #2B638E; border-radius: 999px; }
            .opps-dark-scroll::-webkit-scrollbar-thumb:hover,
            .grid-table-scroll::-webkit-scrollbar-thumb:hover,
            .grid-top-scroll::-webkit-scrollbar-thumb:hover { background: #D4AF37; }

            .orbis-pipeline-board {
                background: #041426;
            }
            .orbis-pipeline-column {
                min-width: 290px;
                border: 1px solid #24587C;
                border-radius: 18px;
                background: #08233D;
                box-shadow: 0 18px 55px rgba(0,0,0,.18);
            }
            .orbis-pipeline-column:nth-child(even) {
                background: #092A49;
            }
            .orbis-pipeline-card {
                border: 1px solid #24587C;
                border-radius: 16px;
                background: rgba(255,255,255,0.045);
                transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
            }
            .orbis-pipeline-card:hover {
                background: rgba(56,189,248,0.075);
                border-color: #D4AF37;
                transform: translateY(-1px);
            }
            .orbis-pipeline-empty {
                border: 1px dashed #24587C;
                border-radius: 16px;
                background: rgba(255,255,255,0.035);
                color: #94a3b8;
            }
        `}</style>
    );
}

const EMPTY_FORM = {
    id: null,
    name: "",
    code: "",
    account_id: "",
    description: "",
    notes: "",

    campaign_id: "",
    pipeline_id: "",
    pipeline_stage_id: "",
    product_line: "ORBIS PMO",
    lead_source: "",

    stage: "",
    probability: "",
    expected_close_date: "",
    estimated_value: "",
    currency: "MXN",
    industry_id: "",

    pain_point: "",
    current_tool: "",
    active_projects_count: "",
    estimated_users: "",
    pilot_package: "",
    pilot_value: "",
    monthly_potential: "",
    decision_maker: "",
    urgency: "",

    next_action: "",
    next_action_date: "",
    status_comment: "",
};

const PILOT_PACKAGES = [
    ["", "— Sin definir —"],
    ["base", "Piloto Base"],
    ["ejecutivo", "Piloto Ejecutivo"],
    ["institucional", "Piloto Institucional"],
    ["personalizado", "Personalizado"],
];

const URGENCY_OPTIONS = [
    ["", "— Sin definir —"],
    ["baja", "Baja"],
    ["media", "Media"],
    ["alta", "Alta"],
    ["critica", "Crítica"],
];

const SOURCE_OPTIONS = [
    ["", "— Sin definir —"],
    ["Landing ORBIS", "Landing ORBIS"],
    ["WhatsApp", "WhatsApp"],
    ["Email", "Email"],
    ["LinkedIn", "LinkedIn"],
    ["Referido", "Referido"],
    ["Contacto directo", "Contacto directo"],
    ["Evento / reunión", "Evento / reunión"],
];

const PRODUCT_LINES = [
    "ORBIS PMO",
    "GreenDoc",
    "SuperLeads",
    "SITIC",
    "RH3",
    "Afiliaciones CANIETI",
    "Otro",
];

function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || "";
    return {
        ...extra,
        Authorization: `Bearer ${token}`,
        "X-CANI-AUTH": token,
    };
}

async function safeJson(url, options = {}) {
    const res = await fetch(url, options);
    const text = await res.text();
    let data = null;

    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        throw new Error(`Respuesta no JSON (${res.status}): ${text.slice(0, 180)}`);
    }

    if (!res.ok || data?.success === false || data?.ok === false) {
        throw new Error(data?.error || data?.detail || `HTTP ${res.status}`);
    }

    return data;
}

function asArray(data) {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.rows)) return data.rows;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.items)) return data.items;
    return [];
}

function toDate(value) {
    if (!value) return "";
    return String(value).slice(0, 10);
}

function toDateTimeLocal(value) {
    if (!value) return "";
    return String(value).replace(" ", "T").slice(0, 16);
}

function normalizeDateTimeForApi(value) {
    if (!value) return "";
    const v = value.replace("T", " ");
    return v.length === 16 ? `${v}:00` : v;
}

function formatCurrency(value, currency = "MXN") {
    if (value === null || value === undefined || value === "") return "—";
    const num = Number(value);
    if (Number.isNaN(num)) return String(value);
    return `${currency || "MXN"} ${num.toLocaleString("es-MX", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })}`;
}


function getOpportunityStatusMeta(opp) {
    const stageCode = String(opp.pipeline_stage_code || "").toLowerCase();
    const stageName = String(opp.pipeline_stage_name || opp.stage || "").toLowerCase();
    const stageType = String(opp.stage_type || "").toLowerCase();
    const probability = Number(opp.probability ?? opp.probability_default ?? 0);

    if (stageType === "ganada" || stageCode.includes("continuidad_mensual") || stageName.includes("continuidad mensual")) {
        return { label: "Continuidad", tone: "green", detail: "Estatus: continuidad" };
    }

    if (stageCode.includes("implementacion_piloto") || stageName.includes("implementación piloto") || stageName.includes("implementacion piloto")) {
        return { label: "Piloto activo", tone: "blue", detail: "Estatus: implementación" };
    }

    if (stageCode.includes("piloto_cerrado") || stageName.includes("piloto cerrado")) {
        return { label: "Piloto cerrado", tone: "green", detail: "Estatus: pendiente activación" };
    }

    if (stageCode.includes("propuesta") || stageName.includes("propuesta")) {
        return { label: "Propuesta", tone: "amber", detail: "Estatus: decisión comercial" };
    }

    if (stageCode.includes("negociacion") || stageName.includes("negociación") || stageName.includes("negociacion")) {
        return { label: "Negociación", tone: "purple", detail: "Estatus: ajuste / cierre" };
    }

    if (stageType === "perdida" || stageCode.includes("perdido") || stageName.includes("perdido")) {
        return { label: "No califica", tone: "red", detail: "Estatus: sin avance" };
    }

    if (probability >= 45) {
        return { label: "En avance", tone: "blue", detail: `Estatus: prob. ${probability}%` };
    }

    if (probability > 0) {
        return { label: "Abierta", tone: "gray", detail: `Estatus: prob. ${probability}%` };
    }

    return { label: "Sin estatus", tone: "gray", detail: "Estatus: sin probabilidad" };
}

function getStatusTone(tone) {
    if (tone === "green") return "border-emerald-400/40 bg-emerald-500/10 text-emerald-100";
    if (tone === "blue") return "border-sky-400/40 bg-sky-500/10 text-sky-100";
    if (tone === "amber") return "border-[#D4AF37]/50 bg-[#D4AF37]/10 text-[#F8E5A4]";
    if (tone === "purple") return "border-violet-400/40 bg-violet-500/10 text-violet-100";
    if (tone === "red") return "border-red-400/40 bg-red-500/10 text-red-100";
    return "border-slate-500/40 bg-white/5 text-slate-200";
}

const MONTHS_ES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

function parseSafeDate(value) {
    if (!value) return null;
    const raw = String(value);
    if (raw.startsWith("0000-00-00")) return null;
    const d = new Date(raw.replace(" ", "T"));
    if (Number.isNaN(d.getTime())) return null;
    return d;
}

function formatHumanDate(value) {
    const d = parseSafeDate(value);
    if (!d) return "—";
    const dd = String(d.getDate()).padStart(2, "0");
    const mmm = MONTHS_ES[d.getMonth()];
    const yyyy = d.getFullYear();
    return `${dd}-${mmm}-${yyyy}`;
}

function formatHumanDateTime(value) {
    const d = parseSafeDate(value);
    if (!d) return "—";

    const date = formatHumanDate(value);
    const time = d.toLocaleTimeString("es-MX", {
        hour: "2-digit",
        minute: "2-digit",
    });

    return `${date} · ${time}`;
}

function formatDateTime(value) {
    return formatHumanDateTime(value);
}

function getUrgencyTone(urgency) {
    const u = String(urgency || "").toLowerCase();
    if (u === "critica") return "border-red-400/40 bg-red-500/10 text-red-100";
    if (u === "alta") return "border-[#D4AF37]/50 bg-[#D4AF37]/10 text-[#F8E5A4]";
    if (u === "media") return "border-amber-400/40 bg-amber-500/10 text-amber-100";
    if (u === "baja") return "border-emerald-400/40 bg-emerald-500/10 text-emerald-100";
    return "border-slate-500/40 bg-white/5 text-slate-200";
}

function getStageTone(stageType) {
    if (stageType === "ganada") return "border-emerald-400/40 bg-emerald-500/10 text-emerald-100";
    if (stageType === "perdida") return "border-red-400/40 bg-red-500/10 text-red-100";
    return "border-sky-400/40 bg-sky-500/10 text-sky-100";
}

function Badge({ children, className = "" }) {
    return (
        <span className={`inline-flex items-center rounded-full border px-3 py-1 text-[10px] font-black ${className}`}>
            {children}
        </span>
    );
}

function KpiCard({ title, value, subtitle, tone = "default" }) {
    const tones = {
        default: "border-[#275A7A]/70 bg-[#08233D]/70",
        blue: "border-sky-400/30 bg-sky-500/10",
        amber: "border-[#D4AF37]/45 bg-[#D4AF37]/10",
        green: "border-emerald-400/35 bg-emerald-500/10",
        red: "border-red-400/35 bg-red-500/10",
        slate: "border-[#275A7A]/70 bg-[#08233D]/70",
    };

    return (
        <div className={`rounded-3xl border p-5 shadow-[0_18px_55px_rgba(0,0,0,.20)] ${tones[tone] || tones.default}`}>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{title}</div>
            <div className="mt-3 text-3xl font-black text-white">{value}</div>
            {subtitle ? <div className="mt-1 text-xs text-slate-400">{subtitle}</div> : null}
        </div>
    );
}

function SectionTitle({ title, subtitle }) {
    return (
        <div className="mb-3">
            <h3 className="text-xs font-bold uppercase tracking-[0.16em] text-[#D4AF37]">{title}</h3>
            {subtitle ? <p className="mt-1 text-xs text-slate-400">{subtitle}</p> : null}
        </div>
    );
}

export default function OpportunitiesPage() {
    const navigate = useNavigate();
    const topScrollRef = useRef(null);
    const tableScrollRef = useRef(null);
    const [topScrollWidth, setTopScrollWidth] = useState(1780);

    const [opportunities, setOpportunities] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [industries, setIndustries] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [pipelines, setPipelines] = useState([]);
    const [pipelineStages, setPipelineStages] = useState([]);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [toast, setToast] = useState(null);

    const [showForm, setShowForm] = useState(false);
    const [formMode, setFormMode] = useState("create");
    const [editingId, setEditingId] = useState(null);
    const [form, setForm] = useState(EMPTY_FORM);

    const [filters, setFilters] = useState(() => {
        try {
            const saved = sessionStorage.getItem("orbis_opportunities_filters");
            if (saved) {
                return {
                    q: "",
                    campaign_id: "",
                    pipeline_id: "",
                    pipeline_stage_id: "",
                    product_line: "",
                    urgency: "",
                    stage_type: "",
                    ...JSON.parse(saved),
                };
            }
        } catch (err) {
            console.warn("No se pudieron restaurar filtros de oportunidades", err);
        }

        return {
            q: "",
            campaign_id: "",
            pipeline_id: "",
            pipeline_stage_id: "",
            product_line: "",
            urgency: "",
            stage_type: "",
        };
    });

    const [sortConfig, setSortConfig] = useState(() => {
        try {
            const saved = sessionStorage.getItem("orbis_opportunities_sort");
            if (saved) return JSON.parse(saved);
        } catch (err) {
            console.warn("No se pudo restaurar orden de oportunidades", err);
        }
        return { key: "next_action_date", direction: "asc" };
    });

    const [viewMode, setViewMode] = useState(() => sessionStorage.getItem("orbis_opportunities_view") || "table");

    async function fetchData() {
        try {
            setLoading(true);
            setError("");

            const [oppData, accData, indData, campData, pipeData, stageData] =
                await Promise.all([
                    safeJson(`${API_BASE}/opportunities_list.php`),
                    safeJson(`${API_BASE}/accounts_list.php`),
                    safeJson(`${API_BASE}/industries_list.php`),
                    safeJson(`${API_BASE}/campaigns_list.php?active_only=1`),
                    safeJson(`${API_BASE}/pipelines_list.php?active_only=1`),
                    safeJson(`${API_BASE}/pipeline_stages_list.php`),
                ]);

            setOpportunities(asArray(oppData));
            setAccounts(asArray(accData));
            setIndustries(asArray(indData));
            setCampaigns(asArray(campData));
            setPipelines(asArray(pipeData));
            setPipelineStages(asArray(stageData));
        } catch (err) {
            console.error(err);
            setError(err.message || "No se pudieron cargar las oportunidades.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        sessionStorage.setItem("orbis_opportunities_filters", JSON.stringify(filters));
    }, [filters]);

    useEffect(() => {
        sessionStorage.setItem("orbis_opportunities_sort", JSON.stringify(sortConfig));
    }, [sortConfig]);

    useEffect(() => {
        sessionStorage.setItem("orbis_opportunities_view", viewMode);
    }, [viewMode]);

    const defaultCampaign = useMemo(() => {
        return campaigns.find((c) => c.code === "ORBIS-PMO-LANZAMIENTO") || campaigns[0] || null;
    }, [campaigns]);

    const defaultPipeline = useMemo(() => {
        return (
            pipelines.find((p) => p.code === "VENTA-ORBIS-PMO") ||
            pipelines.find((p) => Number(p.is_default) === 1) ||
            pipelines[0] ||
            null
        );
    }, [pipelines]);

    const defaultStage = useMemo(() => {
        if (!defaultPipeline) return null;
        return (
            pipelineStages
                .filter((s) => String(s.pipeline_id) === String(defaultPipeline.id))
                .sort((a, b) => Number(a.stage_order || 0) - Number(b.stage_order || 0))[0] ||
            null
        );
    }, [defaultPipeline, pipelineStages]);

    const selectedPipelineStages = useMemo(() => {
        if (!form.pipeline_id) return pipelineStages;
        return pipelineStages.filter(
            (s) => String(s.pipeline_id) === String(form.pipeline_id)
        );
    }, [pipelineStages, form.pipeline_id]);

    const filteredStagesForView = useMemo(() => {
        if (!filters.pipeline_id) return pipelineStages;
        return pipelineStages.filter(
            (s) => String(s.pipeline_id) === String(filters.pipeline_id)
        );
    }, [pipelineStages, filters.pipeline_id]);

    const uniqueProductLines = useMemo(() => {
        const set = new Set(PRODUCT_LINES);
        opportunities.forEach((o) => {
            if (o.product_line) set.add(o.product_line);
        });
        return Array.from(set);
    }, [opportunities]);

    function baseFormDefaults() {
        return {
            ...EMPTY_FORM,
            campaign_id: defaultCampaign?.id ? String(defaultCampaign.id) : "",
            pipeline_id: defaultPipeline?.id ? String(defaultPipeline.id) : "",
            pipeline_stage_id: defaultStage?.id ? String(defaultStage.id) : "",
        };
    }

    function resetForm() {
        setForm(baseFormDefaults());
        setEditingId(null);
        setFormMode("create");
    }

    function openNew() {
        setForm(baseFormDefaults());
        setEditingId(null);
        setFormMode("create");
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function handleEdit(opp) {
        setForm({
            id: opp.id || null,
            name: opp.name || "",
            code: opp.code || "",
            account_id: opp.account_id ? String(opp.account_id) : "",
            description: opp.description || "",
            notes: opp.notes || "",

            campaign_id: opp.campaign_id ? String(opp.campaign_id) : "",
            pipeline_id: opp.pipeline_id ? String(opp.pipeline_id) : "",
            pipeline_stage_id: opp.pipeline_stage_id ? String(opp.pipeline_stage_id) : "",
            product_line: opp.product_line || "ORBIS PMO",
            lead_source: opp.lead_source || opp.source || "",

            stage: opp.stage || opp.legacy_stage || "",
            probability: opp.probability ?? "",
            expected_close_date: opp.expected_close_date ? String(opp.expected_close_date).slice(0, 10) : "",
            estimated_value: opp.estimated_value ?? "",
            currency: opp.currency || "MXN",
            industry_id: opp.industry_id ? String(opp.industry_id) : "",

            pain_point: opp.pain_point || "",
            current_tool: opp.current_tool || "",
            active_projects_count: opp.active_projects_count ?? "",
            estimated_users: opp.estimated_users ?? "",
            pilot_package: opp.pilot_package || "",
            pilot_value: opp.pilot_value ?? "",
            monthly_potential: opp.monthly_potential ?? "",
            decision_maker: opp.decision_maker || "",
            urgency: opp.urgency || "",

            next_action: opp.next_action || "",
            next_action_date: toDateTimeLocal(opp.next_action_date),
            status_comment: opp.status_comment || "",
        });

        setEditingId(opp.id);
        setFormMode("edit");
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function handleChange(e) {
        const { name, value } = e.target;

        setForm((prev) => {
            const next = { ...prev, [name]: value };

            if (name === "pipeline_id") {
                const firstStage = pipelineStages
                    .filter((s) => String(s.pipeline_id) === String(value))
                    .sort((a, b) => Number(a.stage_order || 0) - Number(b.stage_order || 0))[0];

                next.pipeline_stage_id = firstStage?.id ? String(firstStage.id) : "";
            }

            if (name === "pipeline_stage_id") {
                const stage = pipelineStages.find((s) => String(s.id) === String(value));
                if (stage?.probability_default !== null && stage?.probability_default !== undefined) {
                    next.probability = String(stage.probability_default);
                }
            }

            if (name === "pilot_package") {
                if (value === "base" && !next.pilot_value) next.pilot_value = "35000";
                if (value === "ejecutivo" && !next.pilot_value) next.pilot_value = "65000";
                if (value === "institucional" && !next.pilot_value) next.pilot_value = "120000";
            }

            return next;
        });
    }

    function handleFilterChange(e) {
        const { name, value } = e.target;
        setFilters((prev) => {
            const next = { ...prev, [name]: value };
            if (name === "pipeline_id") next.pipeline_stage_id = "";
            return next;
        });
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setError("");
        setToast(null);

        const name = form.name.trim();

        if (!name) {
            setError("El nombre de la oportunidad es obligatorio.");
            return;
        }

        if (!form.account_id) {
            setError("La cuenta es obligatoria.");
            return;
        }

        try {
            setSaving(true);

            const payload = {
                ...form,
                id: editingId,
                name,
                account_id: form.account_id ? Number(form.account_id) : null,
                campaign_id: form.campaign_id ? Number(form.campaign_id) : null,
                pipeline_id: form.pipeline_id ? Number(form.pipeline_id) : null,
                pipeline_stage_id: form.pipeline_stage_id ? Number(form.pipeline_stage_id) : null,
                industry_id: form.industry_id ? Number(form.industry_id) : null,
                probability: form.probability !== "" ? Number(form.probability) : null,
                estimated_value: form.estimated_value !== "" ? Number(form.estimated_value) : null,
                active_projects_count:
                    form.active_projects_count !== "" ? Number(form.active_projects_count) : null,
                estimated_users: form.estimated_users !== "" ? Number(form.estimated_users) : null,
                pilot_value: form.pilot_value !== "" ? Number(form.pilot_value) : null,
                monthly_potential:
                    form.monthly_potential !== "" ? Number(form.monthly_potential) : null,
                next_action_date: normalizeDateTimeForApi(form.next_action_date),
            };

            const endpoint =
                formMode === "edit"
                    ? `${API_BASE}/opportunity_update.php`
                    : `${API_BASE}/opportunity_create.php`;

            await safeJson(endpoint, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            await fetchData();
            setShowForm(false);
            resetForm();

            setToast({
                type: "ok",
                msg: formMode === "edit" ? "Oportunidad actualizada." : "Oportunidad creada.",
            });
        } catch (err) {
            console.error(err);
            setError(err.message || "No se pudo guardar la oportunidad.");
        } finally {
            setSaving(false);
        }
    }

    function getSortValue(row, key) {
        if (!row) return "";

        if (key === "opportunity") return `${row.name || ""} ${row.product_line || ""}`.toLowerCase();
        if (key === "account") return String(row.account_name || "").toLowerCase();
        if (key === "campaign") return `${row.campaign_name || ""} ${row.lead_source || ""}`.toLowerCase();
        if (key === "stage") return Number(row.stage_order || row.probability || 0);
        if (key === "urgency") {
            const weights = { critica: 4, alta: 3, media: 2, baja: 1 };
            return weights[String(row.urgency || "").toLowerCase()] || 0;
        }
        if (key === "values") return Number(row.estimated_value || row.monthly_potential || row.pilot_value || 0);
        if (key === "status") return getOpportunityStatusMeta(row).label.toLowerCase();
        if (key === "next_action") return String(row.next_action || "").toLowerCase();
        if (key === "next_action_date") {
            const d = parseSafeDate(row.next_action_date);
            return d ? d.getTime() : Number.MAX_SAFE_INTEGER;
        }
        if (key === "context") return String(row.pain_point || row.description || "").toLowerCase();

        return String(row[key] || "").toLowerCase();
    }

    function sortBy(key) {
        setSortConfig((prev) => {
            if (prev.key === key) {
                return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
            }
            return { key, direction: key === "next_action_date" || key === "stage" || key === "values" ? "asc" : "asc" };
        });
    }

    function sortIcon(key) {
        if (sortConfig.key !== key) return "↕";
        return sortConfig.direction === "asc" ? "↑" : "↓";
    }

    function openOpportunityDetail(opp) {
        if (!opp?.id) return;
        navigate(`/opportunities/${opp.id}/edit`);
    }

    function syncScroll(source) {
        const top = topScrollRef.current;
        const table = tableScrollRef.current;
        if (!top || !table) return;

        if (source === "top") {
            table.scrollLeft = top.scrollLeft;
        } else {
            top.scrollLeft = table.scrollLeft;
        }
    }

    function updateTopScrollWidth() {
        const table = tableScrollRef.current?.querySelector("table");
        if (!table) return;
        setTopScrollWidth(table.scrollWidth || 1620);
    }

    const filteredOpportunities = useMemo(() => {
        const q = filters.q.trim().toLowerCase();

        const rows = opportunities.filter((opp) => {
            if (filters.campaign_id && String(opp.campaign_id) !== String(filters.campaign_id)) return false;
            if (filters.pipeline_id && String(opp.pipeline_id) !== String(filters.pipeline_id)) return false;
            if (filters.pipeline_stage_id && String(opp.pipeline_stage_id) !== String(filters.pipeline_stage_id)) return false;
            if (filters.product_line && String(opp.product_line || "") !== String(filters.product_line)) return false;
            if (filters.urgency && String(opp.urgency || "") !== String(filters.urgency)) return false;
            if (filters.stage_type && String(opp.stage_type || "") !== String(filters.stage_type)) return false;

            if (q) {
                const haystack = [
                    opp.name,
                    opp.code,
                    opp.account_name,
                    opp.campaign_name,
                    opp.pipeline_name,
                    opp.pipeline_stage_name,
                    opp.product_line,
                    opp.lead_source,
                    opp.pain_point,
                    opp.current_tool,
                    opp.description,
                    opp.notes,
                    opp.next_action,
                    opp.decision_maker,
                    getOpportunityStatusMeta(opp).label,
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase();

                if (!haystack.includes(q)) return false;
            }

            return true;
        });

        const sorted = [...rows].sort((a, b) => {
            const av = getSortValue(a, sortConfig.key);
            const bv = getSortValue(b, sortConfig.key);

            if (typeof av === "number" && typeof bv === "number") {
                return sortConfig.direction === "asc" ? av - bv : bv - av;
            }

            const comp = String(av).localeCompare(String(bv), "es", { sensitivity: "base", numeric: true });
            return sortConfig.direction === "asc" ? comp : -comp;
        });

        return sorted;
    }, [opportunities, filters, sortConfig]);

    useEffect(() => {
        updateTopScrollWidth();
        window.addEventListener("resize", updateTopScrollWidth);
        return () => window.removeEventListener("resize", updateTopScrollWidth);
    }, [filteredOpportunities.length, viewMode]);

    const kpis = useMemo(() => {
        const total = filteredOpportunities.length;
        const open = filteredOpportunities.filter(
            (o) => o.stage_type !== "ganada" && o.stage_type !== "perdida"
        ).length;
        const won = filteredOpportunities.filter((o) => o.stage_type === "ganada").length;
        const lost = filteredOpportunities.filter((o) => o.stage_type === "perdida").length;
        const pilotValue = filteredOpportunities.reduce(
            (sum, o) => sum + (Number(o.pilot_value || 0) || 0),
            0
        );
        const monthlyPotential = filteredOpportunities.reduce(
            (sum, o) => sum + (Number(o.monthly_potential || 0) || 0),
            0
        );

        return { total, open, won, lost, pilotValue, monthlyPotential };
    }, [filteredOpportunities]);

    const groupedByStage = useMemo(() => {
        const map = {};
        filteredStagesForView.forEach((stage) => {
            map[String(stage.id)] = [];
        });

        filteredOpportunities.forEach((opp) => {
            const key = opp.pipeline_stage_id ? String(opp.pipeline_stage_id) : "sin_etapa";
            if (!map[key]) map[key] = [];
            map[key].push(opp);
        });

        return map;
    }, [filteredOpportunities, filteredStagesForView]);

    return (
        <MainLayout>
            <GridRowsProStyle />
            <div className="min-h-screen bg-[#041426] px-6 py-8 text-white opps-dark grid-rows-pro">
                <div className="mx-auto max-w-[1500px] space-y-8"><div className="flex flex-col justify-between gap-5 md:flex-row md:items-end">
                    <div>
                        <p className="mb-3 inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]">
                            <span className="h-px w-10 bg-[#D4AF37]" />
                            CRM Comercial
                        </p>
                        <h2 className="text-4xl font-black tracking-tight md:text-5xl text-white">
                            CRM Ventas / Oportunidades
                        </h2>
                        <p className="mt-4 max-w-3xl text-sm leading-6 text-slate-300">
                            Pipeline comercial multicampaña para ORBIS PMO. Controla leads convertidos, etapas, demos, propuestas, pilotos y continuidad mensual.
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-2 text-xs">
                        <button
                            type="button"
                            onClick={fetchData}
                            className="inline-flex items-center justify-center gap-2 rounded-full border border-[#2B638E] bg-white/5 px-5 py-3 text-sm font-bold text-white hover:bg-white/10"
                        >
                            Recargar
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate("/agenda")}
                            className="inline-flex items-center justify-center gap-2 rounded-full border border-[#2B638E] bg-white/5 px-5 py-3 text-sm font-bold text-white hover:bg-white/10"
                        >
                            Agenda
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate("/opportunities/new")}
                            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#D4AF37] px-5 py-3 text-sm font-black text-[#061A2F] hover:scale-[1.01]"
                        >
                            + Nueva oportunidad
                        </button>
                    </div>
                </div>

                    {toast && (
                        <div
                            className={`text-sm rounded-2xl px-4 py-3 border ${toast.type === "ok" ? "bg-emerald-500/10 text-emerald-100 border-emerald-400/40" : "bg-red-500/10 text-red-100 border-red-400/40"}`}
                        >
                            {toast.msg}
                        </div>
                    )}

                    {error && (
                        <div className="text-sm rounded-2xl px-4 py-3 border bg-red-500/10 text-red-100 border-red-400/40">
                            {error}
                        </div>
                    )}

                    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-6 gap-3">
                        <KpiCard title="Oportunidades" value={kpis.total} subtitle="Resultado filtrado" />
                        <KpiCard title="Abiertas" value={kpis.open} subtitle="Pipeline activo" tone="blue" />
                        <KpiCard title="Ganadas" value={kpis.won} subtitle="Cierre / continuidad" tone="green" />
                        <KpiCard title="Perdidas" value={kpis.lost} subtitle="No calificadas" tone="red" />
                        <KpiCard title="Valor piloto" value={formatCurrency(kpis.pilotValue)} subtitle="Pipeline piloto" tone="amber" />
                        <KpiCard title="Potencial mensual" value={formatCurrency(kpis.monthlyPotential)} subtitle="Continuidad" tone="slate" />
                    </div>

                    {showForm && (
                        <form onSubmit={handleSubmit} className="rounded-3xl border border-[#275A7A]/70 bg-[#08233D]/70 shadow-[0_18px_55px_rgba(0,0,0,.20)] overflow-hidden">
                            <div className="px-5 py-4 border-b border-[#24587C] flex items-start justify-between gap-3">
                                <div>
                                    <h3 className="text-xs font-bold uppercase tracking-[0.16em] text-[#D4AF37]">
                                        {formMode === "create" ? "Nueva oportunidad comercial" : "Editar oportunidad comercial"}
                                    </h3>
                                    <p className="mt-1 text-xs text-slate-400">
                                        Registra campaña, pipeline, etapa, valor piloto, potencial mensual y siguiente acción comercial.
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowForm(false);
                                        resetForm();
                                    }}
                                    className="px-2 py-1 rounded-lg border border-[#24587C] text-[11px] text-slate-200 hover:bg-[#061A2F]"
                                >
                                    Cerrar
                                </button>
                            </div>

                            <div className="p-4 space-y-5 text-xs">
                                <div>
                                    <SectionTitle title="Datos base" subtitle="Cuenta, nombre, producto y valor comercial general." />
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Cuenta *</label>
                                            <select name="account_id" value={form.account_id} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                <option value="">— Seleccionar cuenta —</option>
                                                {accounts.map((a) => (
                                                    <option key={a.id} value={a.id}>
                                                        {a.name}{a.alias ? ` · ${a.alias}` : ""}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Nombre de oportunidad *</label>
                                            <input name="name" value={form.name} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" placeholder="Ej. Piloto ORBIS PMO — Municipio / Empresa" />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Código</label>
                                            <input name="code" value={form.code} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" placeholder="ORBIS-..." />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Línea / producto</label>
                                            <select name="product_line" value={form.product_line} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                {uniqueProductLines.map((line) => (
                                                    <option key={line} value={line}>{line}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Valor estimado general</label>
                                            <input type="number" min="0" name="estimated_value" value={form.estimated_value} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Moneda</label>
                                            <select name="currency" value={form.currency} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                <option value="MXN">MXN</option>
                                                <option value="USD">USD</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <SectionTitle title="Campaña y pipeline" subtitle="Clasificación comercial para saber de dónde viene y en qué etapa está." />
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Campaña</label>
                                            <select name="campaign_id" value={form.campaign_id} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                <option value="">— Sin campaña —</option>
                                                {campaigns.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Pipeline</label>
                                            <select name="pipeline_id" value={form.pipeline_id} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                <option value="">— Sin pipeline —</option>
                                                {pipelines.map((p) => (
                                                    <option key={p.id} value={p.id}>{p.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Etapa</label>
                                            <select name="pipeline_stage_id" value={form.pipeline_stage_id} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                <option value="">— Sin etapa —</option>
                                                {selectedPipelineStages.map((s) => (
                                                    <option key={s.id} value={s.id}>{s.stage_order}. {s.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Probabilidad %</label>
                                            <input type="number" min="0" max="100" name="probability" value={form.probability} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Fuente del lead</label>
                                            <select name="lead_source" value={form.lead_source} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                {SOURCE_OPTIONS.map(([value, label]) => (
                                                    <option key={value} value={value}>{label}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Urgencia</label>
                                            <select name="urgency" value={form.urgency} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                {URGENCY_OPTIONS.map(([value, label]) => (
                                                    <option key={value} value={value}>{label}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Fecha objetivo de cierre</label>
                                            <input type="date" name="expected_close_date" value={form.expected_close_date} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Sector estratégico</label>
                                            <select name="industry_id" value={form.industry_id} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                <option value="">— Sin especificar —</option>
                                                {industries.map((i) => (
                                                    <option key={i.id} value={i.id}>
                                                        {i.name}{i.code ? ` (${i.code})` : ""}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <SectionTitle title="Calificación comercial ORBIS PMO" subtitle="Datos para saber si puede convertirse en piloto pagado y continuidad mensual." />
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                        <div className="md:col-span-2">
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Área a fortalecer</label>
                                            <textarea name="pain_point" value={form.pain_point} onChange={handleChange} rows={3} className="crm-input resize-none" placeholder="Ej. Sin visibilidad, proyectos sin evidencia, tareas vencidas..." />
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Descripción / contexto</label>
                                            <textarea name="description" value={form.description} onChange={handleChange} rows={3} className="crm-input resize-none" placeholder="Contexto general de la oportunidad." />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Herramienta actual</label>
                                            <input name="current_tool" value={form.current_tool} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" placeholder="Excel, Monday, Asana, WhatsApp..." />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Proyectos activos</label>
                                            <input type="number" min="0" name="active_projects_count" value={form.active_projects_count} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Usuarios estimados</label>
                                            <input type="number" min="0" name="estimated_users" value={form.estimated_users} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Decisor / contacto clave</label>
                                            <input name="decision_maker" value={form.decision_maker} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" placeholder="Director, PMO, sponsor..." />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Paquete piloto</label>
                                            <select name="pilot_package" value={form.pilot_package} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                                {PILOT_PACKAGES.map(([value, label]) => (
                                                    <option key={value} value={value}>{label}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Valor piloto</label>
                                            <input type="number" min="0" name="pilot_value" value={form.pilot_value} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Potencial mensual</label>
                                            <input type="number" min="0" name="monthly_potential" value={form.monthly_potential} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" />
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <SectionTitle title="Siguiente acción comercial y seguimiento" subtitle="La oportunidad no debe quedarse sin siguiente paso." />
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        <div className="md:col-span-2">
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Siguiente acción comercial</label>
                                            <input name="next_action" value={form.next_action} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" placeholder="Ej. Enviar propuesta, agendar demo, llamar a director..." />
                                        </div>

                                        <div>
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Fecha siguiente acción comercial</label>
                                            <input type="datetime-local" name="next_action_date" value={form.next_action_date} onChange={handleChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" />
                                        </div>

                                        <div className="md:col-span-3">
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Notas internas comerciales</label>
                                            <textarea name="notes" value={form.notes} onChange={handleChange} rows={3} className="crm-input resize-none" />
                                        </div>

                                        <div className="md:col-span-3">
                                            <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Comentario comercial</label>
                                            <textarea name="status_comment" value={form.status_comment} onChange={handleChange} rows={2} className="crm-input resize-none" placeholder="Lectura ejecutiva breve del estado actual." />
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end gap-2 pt-1 border-t border-[#24587C]">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowForm(false);
                                            resetForm();
                                        }}
                                        className="inline-flex items-center justify-center rounded-full border border-[#2B638E] bg-white/5 px-4 py-2 text-xs font-bold text-white hover:bg-white/10"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={saving}
                                        className="inline-flex items-center justify-center rounded-full bg-[#D4AF37] px-4 py-2 text-xs font-black text-[#061A2F] hover:scale-[1.01] disabled:opacity-60"
                                    >
                                        {saving ? "Guardando..." : formMode === "create" ? "Crear oportunidad" : "Guardar cambios"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}

                    <div className="rounded-3xl border border-[#275A7A]/70 bg-[#08233D]/70 p-5 shadow-[0_18px_55px_rgba(0,0,0,.20)] space-y-3">
                        <div className="flex flex-col xl:flex-row xl:items-end gap-3">
                            <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-6 gap-3 flex-1">
                                <div>
                                    <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Buscar</label>
                                    <input name="q" value={filters.q} onChange={handleFilterChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]" placeholder="Oportunidad, cuenta, área a fortalecer..." />
                                </div>

                                <div>
                                    <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Campaña</label>
                                    <select name="campaign_id" value={filters.campaign_id} onChange={handleFilterChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                        <option value="">Todas</option>
                                        {campaigns.map((c) => (
                                            <option key={c.id} value={c.id}>{c.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Pipeline</label>
                                    <select name="pipeline_id" value={filters.pipeline_id} onChange={handleFilterChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                        <option value="">Todos</option>
                                        {pipelines.map((p) => (
                                            <option key={p.id} value={p.id}>{p.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Etapa</label>
                                    <select name="pipeline_stage_id" value={filters.pipeline_stage_id} onChange={handleFilterChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                        <option value="">Todas</option>
                                        {filteredStagesForView.map((s) => (
                                            <option key={s.id} value={s.id}>{s.stage_order}. {s.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Producto</label>
                                    <select name="product_line" value={filters.product_line} onChange={handleFilterChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                        <option value="">Todos</option>
                                        {uniqueProductLines.map((line) => (
                                            <option key={line} value={line}>{line}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Urgencia</label>
                                    <select name="urgency" value={filters.urgency} onChange={handleFilterChange} className="w-full rounded-2xl border border-[#24587C] bg-white/5 px-4 py-3 text-sm text-white outline-none placeholder:text-slate-500 focus:border-[#D4AF37]">
                                        <option value="">Todas</option>
                                        {URGENCY_OPTIONS.filter(([value]) => value).map(([value, label]) => (
                                            <option key={value} value={value}>{label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="flex gap-2">
                                <button
                                    type="button"
                                    onClick={() => setViewMode("table")}
                                    className={`inline-flex items-center justify-center rounded-full px-4 py-2 text-xs font-black ${viewMode === "table" ? "bg-[#D4AF37] text-[#061A2F]" : "border border-[#2B638E] bg-white/5 text-white hover:bg-white/10"}`}
                                >
                                    Tabla
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setViewMode("pipeline")}
                                    className={`inline-flex items-center justify-center rounded-full px-4 py-2 text-xs font-black ${viewMode === "pipeline" ? "bg-[#D4AF37] text-[#061A2F]" : "border border-[#2B638E] bg-white/5 text-white hover:bg-white/10"}`}
                                >
                                    Pipeline
                                </button>
                            </div>
                        </div>
                    </div>

                    {viewMode === "pipeline" ? (
                        <div className="rounded-3xl border border-[#275A7A]/70 bg-[#08233D]/70 p-3 overflow-x-auto opps-dark-scroll shadow-[0_18px_55px_rgba(0,0,0,.20)]">
                            <div className="flex gap-3 min-w-max bg-[#041426] p-1 rounded-2xl">
                                {filteredStagesForView.map((stage, stageIndex) => {
                                    const rows = groupedByStage[String(stage.id)] || [];
                                    const totalPilot = rows.reduce((sum, o) => sum + (Number(o.pilot_value || 0) || 0), 0);
                                    const columnBg = stageIndex % 2 === 0 ? "#08233D" : "#092A49";

                                    return (
                                        <div
                                            key={stage.id}
                                            className="w-72 shrink-0 rounded-2xl border border-[#24587C] overflow-hidden shadow-[0_18px_55px_rgba(0,0,0,.20)]"
                                            style={{ background: columnBg }}
                                        >
                                            <div className="p-3 border-b border-[#24587C] bg-[#061A2F]/55">
                                                <div className="flex items-center justify-between gap-2">
                                                    <div>
                                                        <div className="text-xs font-bold uppercase tracking-[0.16em] text-[#D4AF37]">
                                                            {stage.stage_order}. {stage.name}
                                                        </div>
                                                        <div className="mt-1 text-xs text-slate-400">
                                                            {rows.length} oportunidad(es) · {formatCurrency(totalPilot)}
                                                        </div>
                                                    </div>
                                                    <span className="h-3 w-3 rounded-full shrink-0" style={{ background: stage.color_hex || "#94A3B8" }} />
                                                </div>
                                            </div>

                                            <div className="p-2 space-y-2 max-h-[70vh] overflow-y-auto opps-dark-scroll">
                                                {rows.length === 0 ? (
                                                    <div className="text-[11px] text-slate-400 p-3 rounded-2xl border border-dashed border-[#24587C] bg-[#061A2F]/45">
                                                        Sin oportunidades en esta etapa.
                                                    </div>
                                                ) : (
                                                    rows.map((opp) => (
                                                        <button
                                                            type="button"
                                                            key={opp.id}
                                                            onClick={() => navigate(`/opportunities/${opp.id}/edit`)}
                                                            className="w-full text-left rounded-2xl border border-[#24587C] bg-[#061A2F]/45 p-3 transition hover:bg-[rgba(56,189,248,0.075)] hover:border-[#D4AF37]"
                                                        >
                                                            <div className="text-xs font-bold uppercase tracking-[0.16em] text-[#D4AF37]">{opp.name}</div>
                                                            <div className="text-[11px] text-slate-400 mt-1">{opp.account_name || "Sin cuenta"}</div>
                                                            <div className="mt-2 flex flex-wrap gap-1">
                                                                {opp.pilot_package && (
                                                                    <Badge className="border-[#D4AF37]/50 bg-[#D4AF37]/10 text-[#F8E5A4]">{opp.pilot_package}</Badge>
                                                                )}
                                                                {opp.urgency && (
                                                                    <Badge className={getUrgencyTone(opp.urgency)}>{opp.urgency}</Badge>
                                                                )}
                                                            </div>
                                                            <div className="mt-2 text-[11px] text-slate-300">
                                                                Piloto: {formatCurrency(opp.pilot_value, opp.currency)}
                                                            </div>
                                                            {opp.next_action && (
                                                                <div className="mt-2 text-[10px] text-slate-400">Próx.: {opp.next_action}</div>
                                                            )}
                                                        </button>
                                                    ))
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <div className="rounded-3xl border border-[#275A7A]/70 bg-[#08233D]/70 shadow-[0_18px_55px_rgba(0,0,0,.20)] overflow-hidden">
                            <div className="px-5 py-4 border-b border-[#24587C] flex items-center justify-between">
                                <div>
                                    <h3 className="text-xs font-bold uppercase tracking-[0.16em] text-[#D4AF37]">Oportunidades comerciales</h3>
                                    <p className="mt-1 text-xs text-slate-400">
                                        {filteredOpportunities.length} resultado(s). Haz clic en el renglón para abrir la Ficha Comercial 360. Ordena columnas desde el encabezado. El grid usa scroll superior, encabezado fijo y ancho extendido.
                                    </p>
                                </div>
                            </div>

                            <div className="space-y-2 grid-rows-pro orbis-grid-pro bg-[#08233D]">
                                <div
                                    ref={topScrollRef}
                                    onScroll={() => syncScroll("top")}
                                    className="grid-top-scroll orbis-grid-top-scroll"
                                    aria-label="Scroll horizontal superior"
                                >
                                    <div className="grid-top-scroll-inner orbis-grid-top-scroll-inner" style={{ width: `${topScrollWidth}px` }} />
                                </div>

                                <div
                                    ref={tableScrollRef}
                                    onScroll={() => syncScroll("table")}
                                    className="grid-table-scroll orbis-grid-table-scroll bg-[#08233D]"
                                >
                                    <table className="min-w-[1780px] w-full text-xs text-slate-200">
                                        <thead className="bg-[#061A2F] sticky-grid-head orbis-sticky-head">
                                            <tr className="text-left text-[11px] font-bold uppercase tracking-[0.12em] text-slate-400">
                                                <th className="px-3 py-2 w-[260px] sortable orbis-sortable" onClick={() => sortBy("opportunity")}>Oportunidad {sortIcon("opportunity")}</th>
                                                <th className="px-3 py-2 w-[190px] sortable orbis-sortable" onClick={() => sortBy("account")}>Cuenta {sortIcon("account")}</th>
                                                <th className="px-3 py-2 w-[210px] sortable orbis-sortable" onClick={() => sortBy("campaign")}>Campaña {sortIcon("campaign")}</th>
                                                <th className="px-3 py-2 w-[190px] sortable orbis-sortable" onClick={() => sortBy("stage")}>Pipeline / etapa {sortIcon("stage")}</th>
                                                <th className="px-3 py-2 w-[120px] sortable orbis-sortable" onClick={() => sortBy("urgency")}>Urgencia {sortIcon("urgency")}</th>
                                                <th className="px-3 py-2 w-[160px] sortable orbis-sortable" onClick={() => sortBy("values")}>Valores {sortIcon("values")}</th>
                                                <th className="px-3 py-2 w-[150px] sortable orbis-sortable" onClick={() => sortBy("status")}>Estado {sortIcon("status")}</th>
                                                <th className="px-3 py-2 w-[230px] sortable orbis-sortable" onClick={() => sortBy("next_action_date")}>Siguiente acción comercial {sortIcon("next_action_date")}</th>
                                                <th className="px-3 py-2 w-[230px] sortable orbis-sortable" onClick={() => sortBy("context")}>Reto / contexto {sortIcon("context")}</th>
                                                <th className="px-3 py-2 w-[90px] text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading && (
                                                <tr>
                                                    <td colSpan={10} className="px-3 py-5 text-center text-slate-400">
                                                        Cargando oportunidades comerciales...
                                                    </td>
                                                </tr>
                                            )}

                                            {!loading && filteredOpportunities.length === 0 && (
                                                <tr>
                                                    <td colSpan={10} className="px-3 py-5">
                                                        <div className="rounded-2xl border border-[#24587C] bg-white/5 p-6 text-center">
                                                            <div className="font-bold text-white">No hay oportunidades con estos filtros.</div>
                                                            <div className="mt-2 text-sm text-slate-400">
                                                                Ajusta campaña, etapa, urgencia o búsqueda para encontrar oportunidades comerciales.
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}

                                            {!loading && filteredOpportunities.map((opp) => {
                                                const status = getOpportunityStatusMeta(opp);

                                                return (
                                                    <tr
                                                        key={opp.id}
                                                        className="border-t border-[#24587C] grid-row-clickable orbis-row-clickable hover:bg-white/5/[0.03]"
                                                        onClick={() => openOpportunityDetail(opp)}
                                                        title="Abrir Ficha Comercial 360"
                                                    >
                                                        <td className="px-3 py-2">
                                                            <div className="font-bold text-white">{opp.name}</div>
                                                            <div className="text-xs text-slate-400">
                                                                {opp.code ? `${opp.code} · ` : ""}
                                                                {opp.product_line || "Sin línea"}
                                                            </div>
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            <div className="font-bold text-white">{opp.account_name || "—"}</div>
                                                            <div className="text-xs text-slate-400">
                                                                {[opp.account_city, opp.account_state].filter(Boolean).join(", ") || "Sin ubicación"}
                                                            </div>
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            <div className="text-xs text-slate-300">{opp.campaign_name || "—"}</div>
                                                            <div className="text-xs text-slate-400">{opp.lead_source || "Sin fuente"}</div>
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            <div className="text-xs text-slate-300">{opp.pipeline_name || "—"}</div>
                                                            <div className="mt-1">
                                                                <Badge className={getStageTone(opp.stage_type)}>
                                                                    {opp.pipeline_stage_name || opp.stage || "Sin etapa"}
                                                                </Badge>
                                                            </div>
                                                            <div className="mt-1 text-xs text-slate-400">
                                                                Prob.: {opp.probability ?? opp.probability_default ?? "—"}%
                                                            </div>
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            <Badge className={getUrgencyTone(opp.urgency)}>
                                                                {opp.urgency || "Sin definir"}
                                                            </Badge>
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            <div className="text-xs text-slate-300">
                                                                Est.: {formatCurrency(opp.estimated_value, opp.currency)}
                                                            </div>
                                                            <div className="text-xs text-slate-400">
                                                                Piloto: {formatCurrency(opp.pilot_value, opp.currency)}
                                                            </div>
                                                            <div className="text-xs text-slate-400">
                                                                Mensual: {formatCurrency(opp.monthly_potential, opp.currency)}
                                                            </div>
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            <Badge className={getStatusTone(status.tone)}>
                                                                {status.label}
                                                            </Badge>
                                                            <div className="mt-1 text-xs text-slate-400">{status.detail}</div>
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            <div className="text-xs text-slate-300">
                                                                {opp.next_action || "Sin siguiente acción comercial"}
                                                            </div>
                                                            <div className="text-xs text-slate-400">
                                                                {opp.next_action_date ? formatDateTime(opp.next_action_date) : "Sin fecha definida"}
                                                            </div>
                                                        </td>
                                                        <td className="px-3 py-2">
                                                            <div className="text-xs text-slate-300">
                                                                {opp.pain_point || opp.description || "Sin área a fortalecer registrada"}
                                                            </div>
                                                            <div className="mt-1 text-xs text-slate-400">
                                                                Herramienta: {opp.current_tool || "—"} · Proyectos: {opp.active_projects_count || "—"} · Usuarios: {opp.estimated_users || "—"}
                                                            </div>
                                                        </td>
                                                        <td className="px-3 py-2 text-right" onClick={(event) => event.stopPropagation()}>
                                                            <button
                                                                type="button"
                                                                onClick={() => openOpportunityDetail(opp)}
                                                                className="rounded-full border border-[#2B638E] bg-white/5 px-3 py-2 text-xs font-bold text-white hover:bg-white/10"
                                                            >
                                                                Editar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </MainLayout>
    );
}
